/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directive, Input } from "@angular/core";

import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzCardGridDirective } from "ng-zorro-antd/card";

@Directive({
  selector: "[ui-card-grid]",
  exportAs: "uiCardGrid",
  host: {
    "[class.ant-card-hoverable]": "nzHoverable",
  },
})
export class UiCardGridDirective extends NzCardGridDirective {
  @Input("uiHoverable") @InputBoolean() public nzHoverable = true;
}
